/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AwardStatusType = "ACTIVE" | "DELETED" | "PENDING" | "%future added value";
export type OverviewAwards_tradeFirm = {
    readonly serviceId: string | null;
    readonly publicProfile: {
        readonly awards: ReadonlyArray<{
            readonly serviceId: string | null;
            readonly name: string | null;
            readonly status: AwardStatusType | null;
        } | null> | null;
    } | null;
    readonly " $refType": "OverviewAwards_tradeFirm";
};
export type OverviewAwards_tradeFirm$data = OverviewAwards_tradeFirm;
export type OverviewAwards_tradeFirm$key = {
    readonly " $data"?: OverviewAwards_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"OverviewAwards_tradeFirm">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "OverviewAwards_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "publicProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "awards",
          "storageKey": null,
          "args": null,
          "concreteType": "AwardType",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "status",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'e22ca3fb0d46abf3d63bcdb3d33db397';
export default node;
